/**
 * 页面状态初始化 Hook
 * 只在客户端使用
 */

import { useEffect, useState } from "react";
import { usePageState } from "@/context/PageStateContext";
import { LocationSource, getLocationInfo } from "@/lib/location";
import { isServer } from "@/lib/constant";
import { reportPerfMetric } from "@/lib/owl";
import { fetchUserInfoClient } from "@/lib/login";

// ============================================
// 客户端数据获取（只在浏览器环境使用）
// ============================================

/**
 * 页面初始化 Hook
 * 在客户端环境下获取用户信息和位置信息
 * 如果 SSR 已经传入了数据，则不重复获取
 */
export function useInitPageState() {
  const { userInfo, setUserInfo, setLocationInfo } = usePageState();
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function init() {
      setError(null);
      try {
        const location = await getLocationInfo();

        if (!userInfo?.isInited) {
          fetchUserInfoClient()
            .then((user) => {
              if (user) setUserInfo(user);
            })
            .catch((err) => {
              console.error("获取用户信息失败", err);
              setError(err as Error);
            });
        }

        if (!isServer) {
          if ((window as any)?.__PAGE_JS_START__) {
            reportPerfMetric({
              key: "pageLocateFinish",
              value: Date.now() - (window as any)?.__PAGE_JS_START__,
              tags: {
                locationSource: location?.actualCityInfo?.source || LocationSource.DEFAULT,
              },
            });
          }
          // 上报定位耗时
          if (window?.__CLIENT_ENTRY_START__) {
            reportPerfMetric({
              key: "pageLocateCost",
              value: Date.now() - window.__CLIENT_ENTRY_START__,
              tags: {
                locationSource: location?.actualCityInfo?.source || LocationSource.DEFAULT,
              },
            });
          }
          // 上报 SSR TTI 时间
          if (window?.__PAGE_TTI_TIME__) {
            const navigationStart = performance.timeOrigin;
            reportPerfMetric({
              key: 'pageTti_SSR',
              value: window.__PAGE_TTI_TIME__ - navigationStart,
            })
            reportPerfMetric({
              key: 'pageTtiTime_SSR',
              value: window.__PAGE_TTI_TIME__,
            })
          }
        }
        if (location) {
          setLocationInfo(location);
        }
      } catch (err) {
        setError(err as Error);
      }
    }

    init();
  }, []);

  return { error };
}
